import { setup } from 'xstate';

export type CameraView = '3d' | 'top' | 'left' | 'right' | 'back';

export interface CameraConfig {
  position: [number, number, number];
  target: [number, number, number];
  fov: number;
  isOrthographic: boolean;
}

export type CameraContext = {
  mode: 'orbit' | 'pan' | 'zoom';
  view: CameraView;
  config: CameraConfig;
};

export type CameraEvent = 
  | { type: 'CAMERA.SET_MODE'; mode: 'orbit' | 'pan' | 'zoom' }
  | { type: 'CAMERA.SET_VIEW'; view: CameraView }
  | { type: 'CAMERA.RESET' };

export const cameraMachine = setup({
  types: {
    context: {} as CameraContext,
    events: {} as CameraEvent,
    input: {} as CameraConfig,
  }
}).createMachine({
  id: 'camera',
  initial: 'idle',
  context: ({ input }) => ({
    mode: 'orbit',
    view: '3d',
    config: input
  }),
  states: {
    idle: {
      entry: () => console.log('Camera Machine Started'),
      on: {
        'CAMERA.SET_MODE': {
          actions: ({ context, event }) => {
            context.mode = event.mode;
          },
          target: 'active'
        },
        'CAMERA.SET_VIEW': {
          actions: ({ context, event }) => {
            context.view = event.view;
          },
          target: 'active'
        }
      }
    },
    active: {
      on: {
        'CAMERA.RESET': {
          target: 'idle'
        },
        'CAMERA.SET_MODE': {
          actions: ({ context, event }) => {
            context.mode = event.mode;
          }
        },
        'CAMERA.SET_VIEW': {
          actions: ({ context, event }) => {
            context.view = event.view;
          }
        }
      }
    }
  }
});
